// Câu lỗi cho NGƯỜI DÙNG từ lỗi axios — MỘT chỗ đọc thân lỗi, dùng được ở cả 3 hệ chạy cnv-ui.
//
// ══ Vì sao phải có (14/09/2026) ══
// react-hot-toast đặt `message` làm CON của phần tử React: đưa vào một OBJECT là React #31
// "Objects are not valid as a React child". Ở hub Work SaaS `<Toaster>` nằm NGOÀI mọi error
// boundary (cnvwork-saas admin/src/main.jsx) ⇒ React gỡ CẢ cây ⇒ trắng NGUYÊN hub, không có cả màn
// «Đã có lỗi xảy ra». Dựng lại được trên bundle prod: `toast.error(e.response?.data?.error || 'Lỗi lưu')`
// của AutomationBuilderPage nhận thân 403 của SaaS ⇒ #root rỗng. Cổng lint chặn tái phạm: luật
// `no-restricted-syntax` trong eslint.config.js.
//
// ══ Ba hình thân lỗi (err.response.data) ══
//   SaaS Work/Connect  { error: { code, message, details }, success?: false, message?: '<câu>' }
//     · `error` là OBJECT.
//     · `message` top-level CHỈ có khi lỗi mang userMessage — câu đã dịch theo ngôn ngữ người dùng.
//     · `error.message` là chuỗi kỹ thuật ('bad input', 'requires scope …') hoặc câu tiếng Việt khi
//       BE ném trần (Connect chưa gắn userMessage cho câu từ chối).
//   Core errorResponse  { success: false, message: '<câu>' }
//   Core route cũ (automation, email-templates…)  { error: '<câu>' } — `error` là CHUỖI.
//
// Đọc theo thứ tự message → error (chuỗi) → error.message → fallback. `message` là hợp đồng «câu cho
// người» nên nhận nguyên. Hai khoá sau thì không, nên chỉ nhận khi TRÔNG như câu người viết: có chữ
// hoa hoặc chữ ngoài ASCII (tiếng Việt có dấu). Chuỗi máy toàn chữ thường ASCII bị bỏ qua — mặc định
// của api/src/shared/errors.js ('bad input', 'flow not found', 'requires permission crm:update'), mã
// lỗi ('template_not_found'), message thô của Postgres: hiện ra còn tệ hơn câu dự phòng của component.
//
// Luôn trả CHUỖI. `fallback` do chỗ gọi dịch sẵn:  toast.error(apiErrorMessage(e, t`Lỗi lưu`))

const HUMAN_TEXT = /[A-Z-￿]/;

const isText = (v) => typeof v === 'string' && v.trim() !== '';

export function apiErrorMessage(err, fallback) {
  const data = err?.response?.data;
  if (data && typeof data === 'object') {
    if (isText(data.message)) return data.message;
    if (isText(data.error) && HUMAN_TEXT.test(data.error)) return data.error;
    const nested = data.error?.message;
    if (isText(nested) && HUMAN_TEXT.test(nested)) return nested;
  }
  return isText(fallback) ? fallback : '';
}
